import type { SVGProps } from 'react'
const LineDog = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		fill="none"
		{...props}
	>
		<path
			fill="currentColor"
			d="M9.5 11.5V11a1 1 0 1 0-2 0v.5a1 1 0 1 0 2 0m7-.5v.5a1 1 0 1 1-2 0V11a1 1 0 1 1 2 0"
		/>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="M3.134 15.694a2.75 2.75 0 0 0 1.788.801q.16.353.376.679l.734 1.101a2.75 2.75 0 0 0 1.47 1.1A2.75 2.75 0 0 0 10.25 22h3.5a2.75 2.75 0 0 0 2.747-2.624 2.75 2.75 0 0 0 1.47-1.1l.735-1.102q.216-.326.376-.678a2.75 2.75 0 0 0 1.788-.801l1.329-1.329A2.75 2.75 0 0 0 23 12.422V8.078c0-.729-.29-1.428-.805-1.944l-3.208-3.207a1.75 1.75 0 0 0-2.474 0l-.06.06A10.46 10.46 0 0 0 12 2c-1.591 0-3.1.353-4.452.987l-.06-.06a1.75 1.75 0 0 0-2.475 0L1.805 6.134A2.75 2.75 0 0 0 1 8.078v4.344c0 .729.29 1.428.805 1.944zM12 3.5a8.95 8.95 0 0 0-4.245 1.06l-.491.264-.837-.837a.25.25 0 0 0-.354 0L2.866 7.195a1.25 1.25 0 0 0-.366.883v4.344c0 .331.132.649.366.883l1.329 1.329q.14.14.316.23a5 5 0 0 1-.011-.325V8.5H6v6.039c0 .642.19 1.269.546 1.803l.734 1.101A1.25 1.25 0 0 0 8.32 18h1.694a1.25 1.25 0 0 0 1.118-.691l.118-.236V16h-.75v-1.5h3V16h-.75v1.073l.118.236a1.25 1.25 0 0 0 1.118.691h1.694a1.25 1.25 0 0 0 1.04-.557l.734-1.101A3.25 3.25 0 0 0 18 14.539V8.5h1.5v6.039q0 .163-.011.325.175-.09.316-.23l1.329-1.329a1.25 1.25 0 0 0 .366-.883V8.078a1.25 1.25 0 0 0-.366-.883l-3.207-3.208a.25.25 0 0 0-.354 0l-.837.837-.49-.263A8.95 8.95 0 0 0 12 3.5m2.975 16h-.989A2.75 2.75 0 0 1 12 18.652a2.75 2.75 0 0 1-1.986.848h-.989c.116.57.62 1 1.225 1h3.5c.605 0 1.11-.43 1.225-1"
			clipRule="evenodd"
		/>
	</svg>
)
export { LineDog }
